import {QueryObserverResult, useQuery, UseQueryResult} from "@tanstack/react-query";
import {fetchStats, fetchUnits, QueryResponse, StatsResponseDto, UnitsResponse} from "@/lib/api";
import {useDashboardOrg} from "@/app/DashboardOrgContext";


export type StatsResponse = {
    messagesPerSecond?: number;
    wupsPerSecond?: number;
    activeDevices: number;
    offlineDevices: number,
    chargingDevices: number,
    unsupportedDevices: number;
    stateDistribution?: Record<string, number>;
    // Fleet protocol-version breakdown (admin snapshot only; {} for org scope) —
    // options source for the Devices page protocol filter.
    protocolCounts: Record<string, number>;
}

export const useStats = ():  StatsResponse&QueryResponse<StatsResponseDto>=> {
    // Manager → org-scoped (/api/org/<id>/stats); admin → fleet snapshot. scopeReady
    // gates so a manager never hits the admin-only fleet endpoint before org select.
    const {dashboardOrgId, scopeReady} = useDashboardOrg();
    const query = useQuery<StatsResponseDto>({
        queryKey: ["stats", dashboardOrgId],
        queryFn: () => fetchStats(dashboardOrgId),
        enabled: scopeReady,
        refetchInterval: 5_000, // WS push handles instant updates; polling is fallback
    });

    return {
        refetch: query.refetch,
        error: query.error,
        loading: query.isLoading,
        messagesPerSecond: query.data?.messages_per_second ?? 0,
        wupsPerSecond: query.data?.wups_per_second ?? 0,
        activeDevices: query.data?.active_units ?? 0,
        offlineDevices: query.data?.state_distribution?.offline ?? 0,
        chargingDevices: query.data?.state_distribution?.charging ?? 0,
        unsupportedDevices: query.data?.unsupported_units ?? 0,
        stateDistribution: query.data?.state_distribution ?? {},
        protocolCounts: query.data?.protocol_counts ?? {}
    }
}